import { iLedgerTransaction } from "@sdk/ledger-transactions/ledger-transactions-models";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";

export const {
  slice: LedgerTransactionsSlice,
  reducers: LedgerTransactionsSliceReducer,
  actions: {
    setEntityQueryResults: setLedgerTransactionsQueryResults,
    setEntity: setLedgerTransaction,
    setEntities: setLedgerTransactions,
    patchEntity: patchLedgerTransaction,
    addNewEntity: addNewLedgerTransaction,
    setEntityFetchingStatus: setLedgerTransactionFetchingStatus,
    setEntitiesFetchingStatus: setLedgerTransactionsFetchingStatus,
    setEntityFailedStatus: setLedgerTransactionFailedStatus,
    setEntityQueryError: setLedgerTransactionsQueryError,
    resetQuery: resetLedgerTransactionsQuery,
    setQueryList: setLedgerTransactionQueryList,
  },
} = CreateEntitySlice<iLedgerTransaction>({
  sliceName: "ledgerTransactions",
});

